import { useMemo } from 'react';

import { useAxiosInstance } from '@/api/useAxiosInstance.util.ts';
import { CONFIG } from '@/config/config.ts';

import {
  AttemptsApiFactory,
  Configuration,
  CsrfApiFactory,
  CurrentUserApiFactory,
  DictionariesApiFactory,
  ExamsApiFactory,
  IntegrationsApiFactory,
  MediaApiFactory,
  PingApiFactory,
  QuestionImpactApiFactory,
  QuestionImportApiFactory,
  QuestionsApiFactory,
  QuestionStatisticsApiFactory,
  SurveyResponsesApiFactory,
  SurveysApiFactory,
  TestPeopleApiFactory,
  TestsApiFactory,
} from './generated';

export type ApiClient = {
  attemptsApi: ReturnType<typeof AttemptsApiFactory>;
  csrfApi: ReturnType<typeof CsrfApiFactory>;
  currentUserApi: ReturnType<typeof CurrentUserApiFactory>;
  dictionariesApi: ReturnType<typeof DictionariesApiFactory>;
  examsApi: ReturnType<typeof ExamsApiFactory>;
  integrationsApi: ReturnType<typeof IntegrationsApiFactory>;
  mediaApi: ReturnType<typeof MediaApiFactory>;
  pingApi: ReturnType<typeof PingApiFactory>;
  questionImpactApi: ReturnType<typeof QuestionImpactApiFactory>;
  questionImportApi: ReturnType<typeof QuestionImportApiFactory>;
  questionsApi: ReturnType<typeof QuestionsApiFactory>;
  questionStatisticsApi: ReturnType<typeof QuestionStatisticsApiFactory>;
  surveyResponsesApi: ReturnType<typeof SurveyResponsesApiFactory>;
  surveysApi: ReturnType<typeof SurveysApiFactory>;
  testPeopleApi: ReturnType<typeof TestPeopleApiFactory>;
  testsApi: ReturnType<typeof TestsApiFactory>;
};

export const useApiClient = (): ApiClient => {
  const axiosInstance = useAxiosInstance();
  const configuration = useMemo(() => getConfiguration(CONFIG.HOST), []);

  return useMemo(
    () => ({
      attemptsApi: AttemptsApiFactory(configuration, undefined, axiosInstance),
      csrfApi: CsrfApiFactory(configuration, undefined, axiosInstance),
      currentUserApi: CurrentUserApiFactory(configuration, undefined, axiosInstance),
      dictionariesApi: DictionariesApiFactory(configuration, undefined, axiosInstance),
      examsApi: ExamsApiFactory(configuration, undefined, axiosInstance),
      integrationsApi: IntegrationsApiFactory(configuration, undefined, axiosInstance),
      mediaApi: MediaApiFactory(configuration, undefined, axiosInstance),
      pingApi: PingApiFactory(configuration, undefined, axiosInstance),
      questionImpactApi: QuestionImpactApiFactory(configuration, undefined, axiosInstance),
      questionImportApi: QuestionImportApiFactory(configuration, undefined, axiosInstance),
      questionsApi: QuestionsApiFactory(configuration, undefined, axiosInstance),
      questionStatisticsApi: QuestionStatisticsApiFactory(configuration, undefined, axiosInstance),
      surveyResponsesApi: SurveyResponsesApiFactory(configuration, undefined, axiosInstance),
      surveysApi: SurveysApiFactory(configuration, undefined, axiosInstance),
      testPeopleApi: TestPeopleApiFactory(configuration, undefined, axiosInstance),
      testsApi: TestsApiFactory(configuration, undefined, axiosInstance),
    }),
    [axiosInstance, configuration],
  );
};

const getConfiguration = (basePath: string): Configuration => ({
  basePath,
  isJsonMime(_mime: string): boolean {
    return true;
  },
});
